import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const SkipContribution = ({ size = 34, style }: IconProps) => {
  const { theme } = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M12.7487 28.3332C15.9126 28.3332 18.5924 27.2353 20.7883 25.0394C22.9841 22.8436 24.082 20.1637 24.082 16.9998C24.082 13.8359 22.9841 11.1561 20.7883 8.96025C18.5924 6.76442 15.9126 5.6665 12.7487 5.6665C9.58481 5.6665 6.90495 6.76442 4.70911 8.96025C2.51328 11.1561 1.41537 13.8359 1.41537 16.9998C1.41537 20.1637 2.51328 22.8436 4.70911 25.0394C6.90495 27.2353 9.58481 28.3332 12.7487 28.3332ZM23.5862 27.9082C26.2543 27.5776 28.4206 26.3557 30.0852 24.2425C31.7497 22.1294 32.582 19.7151 32.582 16.9998C32.582 14.2846 31.7497 11.8703 30.0852 9.75713C28.4206 7.64393 26.2543 6.42206 23.5862 6.0915V8.14567C25.664 8.52345 27.3286 9.55643 28.5799 11.2446C29.8313 12.9328 30.457 14.8512 30.457 16.9998C30.457 19.1484 29.8313 21.0669 28.5799 22.755C27.3286 24.4432 25.664 25.4762 23.5862 25.854V27.9082ZM12.7487 26.2082C10.2223 26.2082 8.05599 25.305 6.24974 23.4988C4.44349 21.6925 3.54037 19.5262 3.54037 16.9998C3.54037 14.4734 4.44349 12.3071 6.24974 10.5009C8.05599 8.69463 10.2223 7.7915 12.7487 7.7915C15.2751 7.7915 17.4414 8.69463 19.2477 10.5009C21.0539 12.3071 21.957 14.4734 21.957 16.9998C21.957 19.5262 21.0539 21.6925 19.2477 23.4988C17.4414 25.305 15.2751 26.2082 12.7487 26.2082Z"
        fill={theme.icon.default}
      />
      <path d="M9.15234 16.3462H16.9985V17.6539H9.15234V16.3462Z" fill={theme.icon.default} />
      <path
        d="M13.255 20.5665L9.68841 16.9999L13.2553 13.433L12.0664 12.2441L8.49954 15.811L7.31066 16.9999L8.49953 18.1888L12.0661 21.7554L13.255 20.5665Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
